export enum InvestigationStatus {
  COMPLETED = 'COMPLETED',
  PARTIALLY_COMPLETED = 'PARTIALLY_COMPLETED',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  EXTRACTING = 'EXTRACTING',
  ANALYZING = 'ANALYZING',
}

export enum InsightState {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

export enum InquiryState {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

export enum FileStateFilter {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  ALL = 'ALL',
}

const getRunningMessage = (isInquiry: boolean) =>
  `Cannot navigate to currently running ${isInquiry ? 'inquiry' : 'investigation'}.`;

export const BLOCKED_STATUS_CONFIG: Partial<
  Record<
    InvestigationStatus,
    { getMessage: (isInquiry: boolean) => string; getDescription: (isInquiry: boolean) => string }
  >
> = {
  [InvestigationStatus.PENDING]: {
    getMessage: getRunningMessage,
    getDescription: (isInquiry) =>
      `The ${isInquiry ? 'inquiry' : 'investigation'} is pending and has not started processing yet.`,
  },
  [InvestigationStatus.EXTRACTING]: {
    getMessage: getRunningMessage,
    getDescription: (isInquiry) =>
      `The ${isInquiry ? 'inquiry' : 'investigation'} is currently being extracted. Please wait until completion.`,
  },
  [InvestigationStatus.ANALYZING]: {
    getMessage: getRunningMessage,
    getDescription: (isInquiry) =>
      `The ${isInquiry ? 'inquiry' : 'investigation'} is currently being analyzed. Please wait until completion.`,
  },
  [InvestigationStatus.FAILED]: {
    getMessage: () => 'Navigation failed.',
    getDescription: (isInquiry) => `The ${isInquiry ? 'inquiry' : 'investigation'} has failed and cannot be navigated.`,
  },
};
